module.exports = __webpack_public_path__ + "img/counter-ico-3.a9aa32eb.svg";